function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.189 30.886a1.2 1.2 0 01-.847-.348 1.184 1.184 0 010-1.681l13.526-13.421L.342 2.014a1.184 1.184 0 010-1.681 1.205 1.205 0 011.694 0l14.372 14.262a1.182 1.182 0 010 1.681L2.036 30.538c-.234.232-.54.348-.847.348z",
  fillRule: "evenodd"
});

var SvgScrollArrow = function SvgScrollArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 17 31"
  }, props), _ref);
};

export default SvgScrollArrow;